import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import GlobalButton from '../../../../shared/globalStyling/Button';
import { Row, Space } from 'antd';
import { isEmpty } from 'lodash';
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import moment from 'moment';

//Export Buttons on the top right of the page
const ExportButtons = ({
  exportData = false,
  reportData,
  currentTab = 'summary',
  name = '',
  deviceFilter = null,
}) => {
  if (exportData) {
    const sanitizeFilename = (str) => {
      return str
        .replace(/[<>:"|?*\\\/]/g, '_') // Replace problematic filesystem characters
        .replace(/\s+/g, '_') // Convert spaces to underscores
        .replace(/_+/g, '_'); // Collapse multiple underscores
    };

    const formattedTab = currentTab
      ? currentTab.charAt(0).toUpperCase() + currentTab.slice(1).replace(/[\W_]/g, '_')
      : 'Summary';

    const deviceSuffix =
      currentTab === 'keywords' && deviceFilter
        ? `(${deviceFilter?.charAt(0)?.toUpperCase() + deviceFilter?.slice(1) || ''})`
        : '';

    const filename = sanitizeFilename(
      `${formattedTab}_${name}${deviceSuffix}_${moment.utc().format('MMM-DD-YYYY')}`
    );

    // Export Excel
    const handleExportExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(reportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const excelData = new Blob([excelBuffer], { type: fileType });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(excelData);
      const decodedFileName = decodeURIComponent(filename) + '.xlsx';
      link.download = decodedFileName;
      link.click();
    };

    return (
      <React.Fragment>
        <Row>
          <Space className="ant-space-xs-vertical ant-space-md-horizontal ant-space-xs-gap-small ant-space-md-gap-middle">
            <GlobalButton disabled={isEmpty(reportData)} type="primary">
              <CSVLink filename={`${filename}.csv`} data={reportData}>
                <Space size="small" direction="horizontal">
                  <DownloadOutlined /> Export CSV
                </Space>
              </CSVLink>
            </GlobalButton>
            <GlobalButton disabled={isEmpty(reportData)} type="primary" onClick={handleExportExcel}>
              <Space size="small" direction="horizontal">
                <DownloadOutlined /> Export Excel
              </Space>
            </GlobalButton>
          </Space>
        </Row>
      </React.Fragment>
    );
  }
  //Don't show anything if exportData is false
  return <></>;
};

export default ExportButtons;
